import { render } from "./Payxpert.vue?vue&type=template&id=38d73a58&scoped=true"
import script from "./Payxpert.vue?vue&type=script&lang=js"
export * from "./Payxpert.vue?vue&type=script&lang=js"

import "./Payxpert.vue?vue&type=style&index=0&id=38d73a58&lang=css"
import "./Payxpert.vue?vue&type=style&index=1&id=38d73a58&lang=scss&scoped=true"

import exportComponent from "/home/smartphone/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d73a58"]])

export default __exports__